/**
 * Root redirect — sends admin → /admin, client → /portal, unauthenticated → /login
 */

import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export function RoleRedirect() {
  const { isAuthenticated, isAdmin, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#0d0d0d', color: '#94a3b8' }}>
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (isAdmin) return <Navigate to="/admin" replace />;
  return <Navigate to="/portal" replace />;
}
